module.exports = __webpack_public_path__ + "static/media/grid-metro-2.3f62cd16.jpg";